// X の投稿画面（Web Intent）。投稿するかどうかはワーカー自身が決める
const X_INTENT_URL = "https://twitter.com/intent/tweet";

// 投稿文の仮の文言（正式な文言が決まったら差し替える）
export const WORK_COMPLETION_SHARE_TEXT = "ケアリンクでお仕事が完了しました！";

// 共有 URL に付ける参照トークンのクエリ名。トップページはこの値で OGP 画像を出し分ける
export const SHARE_TOKEN_PARAM = "share_token";

/**
 * SNS に載せるトップページの URL。
 * 流入を計測する UTM パラメータと、OGP 画像を出し分ける参照トークンを付ける
 */
export function buildWorkCompletionShareUrl(
  baseUrl: string,
  shareToken: string,
): string {
  const url = new URL("/", baseUrl);
  url.searchParams.set("utm_source", "sns_share");
  url.searchParams.set("utm_medium", "x");
  url.searchParams.set("utm_campaign", "work_completion");
  url.searchParams.set(SHARE_TOKEN_PARAM, shareToken);
  return url.toString();
}

/**
 * X の投稿画面を、投稿文とトップページの URL を入れた状態で開く URL。
 * トップページの URL が組み立てられないときは null（報酬確定ダイアログを落とさず、共有ボタンを出さない）
 */
export function buildXShareIntentUrl(
  baseUrl: string | undefined,
  shareToken: string,
): string | null {
  if (!baseUrl) return null;

  let shareUrl: string;
  try {
    shareUrl = buildWorkCompletionShareUrl(baseUrl, shareToken);
  } catch {
    return null;
  }

  const url = new URL(X_INTENT_URL);
  url.searchParams.set("text", WORK_COMPLETION_SHARE_TEXT);
  url.searchParams.set("url", shareUrl);
  return url.toString();
}
